import styled from 'styled-components'
import { Box } from '@realsoftworks/decor'

export default styled(Box)`
  & > *:not(:first-child) {
    border-top: 1px solid ${p => p.theme.colors.neutral[200]};
  }
`
